import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';

import { type CalendarDefinition } from './calendar.definition';

export class CalendarDefinitionMapper implements DefinitionMapper<'calendar'> {
  readonly type = 'calendar';

  extract(element: CanvasElementFrom<'calendar'>): PartialDeep<CalendarDefinition> {
    const content = element.props.content;

    return {
      actions: Object.entries({
        Edit: content.itemEdit?.enabled || false,
        Add: content.itemAdd?.enabled || false,
        Delete: content.itemDelete?.enabled || false,
        View: content.itemViewDialog?.enabled || false,
      })
        .filter(([_, enabled]) => enabled)
        .map(([key]) => key) as CalendarDefinition['actions'],

      titleColumn: content?.input.titleColumn,
      startColumn: content?.input.startColumn,
      endColumn: content?.input.endColumn,
      calendarColumn: content?.input.calendarColumn,
      timeZoneColumn: content?.input.timeZoneColumn,

      dragAndDrop: !content.calendarOptions.disableEventDrag,
    };
  }
}
